import React from "react";
import classnames from "classnames";
import { calculateDeliveryDate } from "../../../utils/functions";
import MealItem from "./../../molecules/MealItem";
import { ReactComponent as BackArrow } from "./../../atoms/icons/chevron-back.svg";
import {
  Wrap,
  MainHeading,
  BackButton,
  BackLink,
  Breakfasts,
  Entrees,
  SectionWrap,
  BreakfastsSectionHeading,
  EntreeSectionHeading,
} from "./styles";
import { setWrapClass } from "./utils";

function MealList(props) {
  const { charge, breakfasts, entrees, selectedMeals, limitations, dietType, bundleTitle, compactHeader, mode, configPageUrl, main_title } = props;

  let _charge = { ...charge };

  const getDietTypeTitle = (type) => {
    switch (type) {
      case "Mediterranean Plan":
        return "Mediterranean";
      case "Low-FODMAP Plan":
        return "Low-FODMAP";
      case "Diabetes Plan":
        return "Diabetes-Friendly";
      case "Gluten-Free Plan":
        return "Gluten-Free";
      case "Heart-Friendly Plan":
        return "Heart-Friendly";
      case "Carb-Conscious Plan":
        return "Carb-Conscious";
      case "B2B Plan":
        return "B2B";
      case "Care Plan":
        return "Care";
      case "GLP-1 Plan":
        return "GLP-1";
      default:
        return "404";
    }
  };

  const handleMealChange = (item) => {
    props.handleMealChange(item);
  };

  const handlePrevClick = () => {
    props.handlePrevClick();
  };

  const hideMealBlock = (data) => {
    let mark = true;
    data.forEach((item) => {
      if (!item.hidden) mark = false;
    });
    return mark;
  };

  let deliveryDate = calculateDeliveryDate(_charge.scheduledAt, "long");

  let hideBreakfasts = hideMealBlock(breakfasts);
  let hideEntrees = hideMealBlock(entrees);

  const dietTypeTitle = getDietTypeTitle(dietType);
  const wrapClass = setWrapClass(limitations || { breakfastsMinLimit: 0, entreesMinLimit: 0 });
  const _mealType = typeof main_title !== "undefined" ? main_title : dietType;

  return (
    <>
      {mode === "constructor" && (
        <MainHeading className={classnames({ active: compactHeader })}>
        <BackLink href={configPageUrl}>
          <BackArrow />
        </BackLink>
         <span id="diet_type">
            {bundleTitle ? `Select your ${bundleTitle} Meals` : `Select your ${dietTypeTitle} Meals`}
          </span>
      </MainHeading>
      )}
      {mode === "account" && (
        <>
          <MainHeading className={classnames({ active: compactHeader })}>
            <BackButton onClick={handlePrevClick}>
              <BackArrow />
            </BackButton>
            All Meals For This Week
          </MainHeading>
          <p>Editing meals for {deliveryDate}</p>
        </>
      )}
      <p>Click on each meal to view ingredients and nutritional information.</p>
      <Wrap className={classnames(wrapClass)}>
      {breakfasts.length > 0 && !hideBreakfasts && _mealType !== "Mediterranean Plan" && _mealType !== "Diabetes Plan"&& (
          <Breakfasts>
            <BreakfastsSectionHeading>Breakfasts</BreakfastsSectionHeading>
            <SectionWrap>
              {breakfasts.map((meal) => {
                let breakfastsQuantitySelected = 0;
                selectedMeals.breakfasts.forEach((item) => {
                  if (meal.id === item.id) {
                    breakfastsQuantitySelected = item.quantity;
                    return false;
                  }
                });
                return (
                  !meal.hidden && (
                    <MealItem
                      id={meal.id}
                      type={meal.type}
                      price={meal.price}
                      excluded={typeof meal.excluded !== "undefined" ? meal.excluded : false}
                      hidden={typeof meal.hidden !== "undefined" ? meal.hidden : false}
                      title={meal.title}
                      image={meal.image}
                      tags={meal.tags}
                      key={meal.id}
                      variants={meal.variants}
                      mealChange={handleMealChange}
                      images={meal.images}
                      handle={meal.handle}
                      mealBoughtQuantity={meal.mealBoughtQuantity}
                      stockCapacity={meal.stockCapacity}
                      quantitySelected={breakfastsQuantitySelected}
                      frequence={"recurring"}
                      view={"standart"}
                      deliveryItem={false}
                      charge={charge}
                    />
                  )
                );
              })}
            </SectionWrap>
          </Breakfasts>
        )}

        {entrees.length > 0 && !hideEntrees && (
          <Entrees>
            <EntreeSectionHeading>Entrées</EntreeSectionHeading>
            <SectionWrap>
              {entrees.map((meal) => {
                let entreesQuantitySelected = 0;
                selectedMeals.entrees.forEach((item) => {
                  if (meal.id === item.id) {
                    entreesQuantitySelected = item.quantity;
                    return false;
                  }
                });
                return (
                  !meal.hidden && (
                    <MealItem
                      id={meal.id}
                      excluded={typeof meal.excluded !== "undefined" ? meal.excluded : false}
                      hidden={typeof meal.hidden !== "undefined" ? meal.hidden : false}
                      title={meal.title}
                      image={meal.image}
                      tags={meal.tags}
                      key={meal.id}
                      variants={meal.variants}
                      mealChange={handleMealChange}
                      images={meal.images}
                      handle={meal.handle}
                      mealBoughtQuantity={meal.mealBoughtQuantity}
                      stockCapacity={meal.stockCapacity}
                      quantitySelected={entreesQuantitySelected}
                      frequence={"recurring"}
                      view={"standart"}
                      deliveryItem={false}
                      charge={charge}
                    />
                  )
                );
              })}
            </SectionWrap>
          </Entrees>
        )}
      </Wrap>
    </>
  );
}

export default MealList;
 